import React, { useEffect, useState } from "react"
import { ImageHeader } from "../../components/imageHeader"

import HeaderImage from "../../images/crete-your-own-heidi-header.jpg"
import InstagramFeed from "../../images/instagram-feed.jpg"

import { AppButton } from "../../components/button"
import { Divider } from "../../components/divider"
import { Footer } from "../../components/footer/Footer"
import Navbar from "../../components/navbar/Navbar"
import "./index.scss"
import { BookSeminarModal } from "../../components/bookSeminarModal"
import { graphql } from "gatsby"
import { getFooterConfigObject, getMenuConfigObject } from "../../utils/graphqlUtils"
import { RichText } from "prismic-reactjs"
import Swiper from "swiper"
import desktopDelimiter from "../../images/delimiter_desktop.png"
import logo from "../../images/heidi-logo.png"
import * as moment from "moment"
import RoundedClose from "../../images/close.png"
import Delimiter from "../../images/curve.png"
import "moment/min/locales"
import TemplateWrapper from "../../components/layout"

export const CreateYourOwnHeidi = ({ data, ...props }) => {

  const getCreateHeidiData = data && data.prismic && data.prismic.allCreate_your_own_heidi_pages && data.prismic.allCreate_your_own_heidi_pages.edges && data.prismic.allCreate_your_own_heidi_pages.edges[0].node
  // console.log("create heidi data", getCreateHeidiData)

  const [open, setOpen] = useState(false)
  const [detailsIndex, setDetailsIndex] = useState(null)
  const [selectedDuration, setSelectedDuration] = useState(1)

  useEffect(() => {
    const swiper = new Swiper(".swiper-container", {
      autoplay: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false
      }
    })
  }, [data])

  const getTimeInterval = (startingDayOfWeek, endingDayOfWeek, startingHour, endingHour) => {
    const hours = " " + startingHour + " - " + endingHour
    const locale = props.pageContext.lang || "en"
    const currentDate = moment()
    if (startingDayOfWeek !== endingDayOfWeek) {
      return moment(currentDate.day(startingDayOfWeek), ["d"]).locale(locale).format("dddd") + " - " + moment(currentDate.day(endingDayOfWeek), ["d"]).locale(locale).format("dddd") + hours
    } else {
      return moment(currentDate.day(startingDayOfWeek), ["d"]).locale(locale).format("dddd") + hours
    }
  }

  const getStoreTimeIntervals = () => {
    if (!getCreateHeidiData.concept_store?.schedule) return ""

    return getCreateHeidiData.concept_store.schedule.map(interval => {
      return getTimeInterval(
        interval.starting_day && interval.starting_day[0],
        interval.ending_day && interval.ending_day[0],
        interval.start_hour,
        interval.end_hour
      )
    }).join(" \n ")
  }

  const isInInterval = (startingDay, endingDay, startingHour, endingHour) => {
    if (!startingDay || !endingDay || !startingHour || !endingHour) return

    const currentDay = moment().day()
    const currentHour = moment().hours()
    const formattedStartingHour = moment(startingHour, ["h A"]).hours()
    const formattedEndingHour = moment(endingHour, ["h A"]).hours()


    if (
      (currentDay >= startingDay && currentDay <= endingDay) &&
      (currentDay >= startingDay && currentDay <= endingDay) &&
      (currentHour >= formattedStartingHour && currentHour < formattedEndingHour)
    ) {
      return true
    }
    return false
  }

  const isStoreOpen = () => {
    if (!getCreateHeidiData.concept_store?.schedule) return false

    const int = getCreateHeidiData.concept_store.schedule.map(interval => (isInInterval(
      interval.starting_day && interval.starting_day[0],
      interval.ending_day && interval.ending_day[0],
      interval.start_hour,
      interval.end_hour
    )))

    return !!int.find(v => v)

  }

  // console.log("open", isStoreOpen(), "interval", getStoreTimeIntervals())

  return (
    <TemplateWrapper>
      <div id="what-create-your-own-heidi">
        <Navbar {...props} menuObject={getMenuConfigObject(data)} data={data}/>
        {getCreateHeidiData &&
        <div>
          <div className="d-block d-sm-none">
            <div>
              {getCreateHeidiData.header_video && getCreateHeidiData.header_video.url &&
              <div style={{ height: "500px", width: "100%", position: "relative" }}>
                <video autoPlay="autoPlay" muted playsInline loop style={{ width: "100%", height: "100%", objectFit: "cover" }}
                       src={getCreateHeidiData.header_video.url}/>
                <div className="app-image-header-delimiter"
                     style={{ backgroundImage: `url('${Delimiter}')` }}/>
              </div>
              }
              {!(getCreateHeidiData.header_video && getCreateHeidiData.header_video.url) &&
              <ImageHeader imgSrc={getCreateHeidiData.header_image && getCreateHeidiData.header_image.url ? getCreateHeidiData.header_image.url : HeaderImage}/>
              }
            </div>
            <div className="container mobile-content">
              <div className="text-center">
                <img className="img-fluid my-sm-5"
                     src={logo} width="100px"/>
                {getCreateHeidiData.page_title && getCreateHeidiData.page_title[0] ? RichText.render(getCreateHeidiData.page_title) : "CREATE YOUR OWN HEIDI"}
                {getCreateHeidiData.page_description && getCreateHeidiData.page_description[0] && RichText.render(getCreateHeidiData.page_description)}
                <AppButton href="#seminars-mobile">{getCreateHeidiData.top_button_text ? getCreateHeidiData.top_button_text : "join a seminar"}</AppButton>
                <Divider/>
                {getCreateHeidiData.seminar_section_title && getCreateHeidiData.seminar_section_title[0] && RichText.render(getCreateHeidiData.seminar_section_title)}
                {/*<div>*/}
                {/*  <img className="img-fluid rounded" src={ChocolateSeminar} alt=""/>*/}
                {/*</div>*/}
                {getCreateHeidiData.seminar_section_video && getCreateHeidiData.seminar_section_video.url &&
                <video autoPlay="autoPlay" muted playsInline loop style={{ width: "100%", height: "100%", objectFit: "cover" }}
                       src={getCreateHeidiData.seminar_section_video.url}/>
                }
                {!(getCreateHeidiData.seminar_section_video && getCreateHeidiData.seminar_section_video.url) &&
                <div className="swiper-container overflow-hidden mt-0 mt-sm-5 mb-4">
                  <div className="swiper-wrapper">
                    {getCreateHeidiData.seminar_images_slider && getCreateHeidiData.seminar_images_slider.length && getCreateHeidiData.seminar_images_slider.map((slide, index) =>
                      <div className="swiper-slide" key={index.toString()}>
                        <img className="img-fluid" src={slide.seminar_slide_image.url}/>
                      </div>
                    )}
                  </div>
                  <div className="swiper-scrollbar"/>
                </div>
                }
                {getCreateHeidiData.seminar_section_description && getCreateHeidiData.seminar_section_description[0] && RichText.render(getCreateHeidiData.seminar_section_description)}
                <Divider/>
                {getCreateHeidiData.seminar && getCreateHeidiData.seminar.length && getCreateHeidiData.seminar.map((seminar, index) =>
                  <div key={index.toString()} id="seminars-mobile" className="d-flex seminar-pricing">
                    <div className="col p-0 text-center position-relative">
                      {detailsIndex === index &&
                      <div>
                        <div className="modal-overlay" onClick={() => setDetailsIndex(null)}/>
                        <div className="nutrition-info-modal text-center">
                          <img className="img-fluid close-overlay" src={RoundedClose} onClick={() => setDetailsIndex(null)}/>
                          <div className="container">
                            <div className="row">
                              <div className="col-12 p-0 pt-4">
                                <h1>{seminar.seminar_title && seminar.seminar_title[0] && RichText.asText(seminar.seminar_title)}</h1>
                                <div className="divider my-3"/>
                                {seminar.seminar_extended_description && seminar.seminar_extended_description[0] && RichText.render(seminar.seminar_extended_description)}
                                <div className="divider my-3"/>
                                <span className="seminar-costs">
                              {seminar.seminar_cost_details && seminar.seminar_cost_details[0] && RichText.render(seminar.seminar_cost_details)}
                            </span>
                                {!seminar.disabled &&
                                <AppButton onClick={() => {
                                  setOpen(true)
                                  setSelectedDuration(index)
                                }} className="green-button">{seminar.button_text ? seminar.button_text : "book now"}
                                </AppButton>
                                }
                                {seminar.disabled &&
                                <AppButton onClick={() => {
                                  setOpen(true)
                                  setSelectedDuration(index)
                                }} className="disabled-button">{seminar.seminar_disabled_button_text}
                                </AppButton>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                      {seminar.seminar_title && seminar.seminar_title[0] && RichText.render(seminar.seminar_title)}
                      {seminar.seminar_short_description && seminar.seminar_short_description[0] && RichText.render(seminar.seminar_short_description)}
                      <div onClick={() => setDetailsIndex(index)}
                           className="see-more-details-link mb-4"><span>{seminar.see_more_details_text ? seminar.see_more_details_text : "see more details"}</span></div>
                      {!seminar.disabled &&
                      <AppButton className="green-button" onClick={() => {
                        setOpen(true)
                        setSelectedDuration(index)
                      }}>{seminar.button_text ? seminar.button_text : "book now"}
                      </AppButton>
                      }
                      {seminar.disabled &&
                      <AppButton className="disabled-button" onClick={() => {
                        setOpen(true)
                        setSelectedDuration(index)
                      }}>{seminar.seminar_disabled_button_text}
                      </AppButton>
                      }
                    </div>
                  </div>
                )}
                <Divider/>
              </div>
            </div>
          </div>
          <div className="d-none d-sm-block">
            <div className="homepage-desktop">
              <section className="container-fluid p-0">
                <div className="row m-0">
                  <div className="page-container d-flex">
                    {!(getCreateHeidiData.header_video && getCreateHeidiData.header_video.url) &&
                    <div className="desktop-left-section" style={{ backgroundImage: `url('${getCreateHeidiData.header_image.url}')` }}>
                      <div className="desktop-section-delimiter"
                           style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
                    </div>
                    }
                    {getCreateHeidiData.header_video && getCreateHeidiData.header_video.url &&
                    <div className="desktop-left-section">
                      <video autoPlay="autoPlay" muted playsInline loop style={{ width: "100%", height: "100%", objectFit: "cover" }}
                             src={getCreateHeidiData.header_video.url}/>
                      <div className="desktop-section-delimiter"
                           style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
                    </div>
                    }
                    <div className="desktop-right-section d-flex flex-column align-items-center justify-content-center"/>
                    <div className="container position-absolute desktop-right-container p-0">
                      <div className="row m-0 justify-content-end">
                        <div className="col-6 pl-5 pr-0 text-center">
                          <img className="img-fluid my-4" src={logo} alt="Heidi journey" style={{ width: "70px" }}/>
                          <div className="text-center">
                            {getCreateHeidiData.page_title && getCreateHeidiData.page_title[0] && RichText.render(getCreateHeidiData.page_title)}
                            <div
                              className="desktop-header-description text-center">{getCreateHeidiData.page_description && getCreateHeidiData.page_description[0] && RichText.render(getCreateHeidiData.page_description)}</div>
                            <AppButton href="#book-seminar">{getCreateHeidiData.top_button_text ? getCreateHeidiData.top_button_text : "book now"}</AppButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="homepage-desktop">
              <section className="container-fluid p-0">
                <div className="row m-0">
                  <div className="page-container d-flex">
                    <div className="desktop-left-section">
                      {getCreateHeidiData.seminar_section_video && getCreateHeidiData.seminar_section_video.url &&
                      <video autoPlay="autoPlay" muted playsInline loop style={{ width: "100%", height: "100%", objectFit: "cover" }}
                             src={getCreateHeidiData.seminar_section_video.url}/>
                      }
                      {!(getCreateHeidiData.seminar_section_video && getCreateHeidiData.seminar_section_video.url) &&
                      <div className="swiper-container overflow-hidden slideshow-container" style={{ minHeight: "100vh" }}>
                        <div className="swiper-wrapper">
                          {getCreateHeidiData.seminar_images_slider && getCreateHeidiData.seminar_images_slider.length && getCreateHeidiData.seminar_images_slider.map((slide, index) =>
                            <div className="swiper-slide background-image-slide" key={index.toString()}
                                 style={{ backgroundImage: `url('${slide.seminar_slide_image.desktop.url ? slide.seminar_slide_image.desktop.url : slide.seminar_slide_image.url}')` }}/>
                          )}
                        </div>
                        <div className="swiper-scrollbar"/>
                      </div>
                      }
                      <div className="desktop-section-delimiter"
                           style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
                    </div>
                    <div className="desktop-right-section d-flex flex-column align-items-center justify-content-center">
                      <div className="container position-absolute desktop-right-container p-0">
                        {detailsIndex != null && <div className="modal-overlay" onClick={() => setDetailsIndex(null)}/>}
                        <div className="row m-0 justify-content-end">
                          <div className="col-6 pr-0 text-center seminar-section-container">
                            {getCreateHeidiData.mountains_decorator && <img className="img-fluid my-4" src={getCreateHeidiData.mountains_decorator.url}/>}
                            {getCreateHeidiData.seminar_section_title && getCreateHeidiData.seminar_section_title[0] && RichText.render(getCreateHeidiData.seminar_section_title)}
                            {getCreateHeidiData.seminar_section_description && getCreateHeidiData.seminar_section_description[0] && RichText.render(getCreateHeidiData.seminar_section_description)}
                            <div className="divider"/>
                            {getCreateHeidiData.seminar && getCreateHeidiData.seminar.length && getCreateHeidiData.seminar.map((seminar, index) =>
                              <div key={index.toString()} id="book-seminar" className="d-flex seminar-pricing mb-5">
                                <div className="col p-0 text-center position-relative">
                                  {detailsIndex === index &&
                                  <div className="nutrition-info-modal text-center">
                                    <img className="img-fluid close-overlay" src={RoundedClose} onClick={() => setDetailsIndex(null)}/>
                                    <div className="container pt-3">
                                      <div className="row">
                                        <div className="col-12">
                                          <h1>{seminar.seminar_title && seminar.seminar_title[0] && RichText.asText(seminar.seminar_title)}</h1>
                                          <div className="divider"/>
                                          {seminar.seminar_extended_description && seminar.seminar_extended_description[0] && RichText.render(seminar.seminar_extended_description)}
                                          <div className="divider"/>
                                          <div className="seminar-costs">
                                            {seminar.seminar_cost_details && seminar.seminar_cost_details[0] && RichText.render(seminar.seminar_cost_details)}
                                          </div>
                                          {!seminar.disabled &&
                                          <AppButton onClick={() => {
                                            setOpen(true)
                                            setSelectedDuration(1)
                                          }} className="green-button">{seminar.button_text ? seminar.button_text : "book now"}
                                          </AppButton>
                                          }
                                          {seminar.disabled &&
                                          <AppButton className="disabled-button small-button">{seminar.seminar_disabled_button_text}</AppButton>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  }
                                  {seminar.seminar_title && seminar.seminar_title[0] && RichText.render(seminar.seminar_title)}
                                  {seminar.seminar_short_description && seminar.seminar_short_description[0] && RichText.render(seminar.seminar_short_description)}
                                  <div onClick={() => setDetailsIndex(index)}
                                       className="see-more-details-link mb-4">
                                    <span>{seminar.see_more_details_text ? seminar.see_more_details_text : "see more details"}</span></div>
                                  {!seminar.disabled &&
                                  <AppButton onClick={() => {
                                    setOpen(true)
                                    setSelectedDuration(2)
                                  }} className="green-button">{seminar.button_text ? seminar.button_text : "book now"}
                                  </AppButton>
                                  }
                                  {seminar.disabled &&
                                  <AppButton className="disabled-button">{seminar.seminar_disabled_button_text}</AppButton>
                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="container">
            {getCreateHeidiData && getCreateHeidiData.promo_section && getCreateHeidiData.promo_section[0] && !getCreateHeidiData.promo_section[0].disabled &&
            <div className="pt-5 text-center">
              <a href={getCreateHeidiData.promo_section[0]?.promo_link?.url}>
                <img src={getCreateHeidiData.promo_section[0]?.promo_button_icon?.url}/>
              </a>
              <span className="d-block py-3 promo-cta">
            {getCreateHeidiData.promo_section && getCreateHeidiData.promo_section[0] && getCreateHeidiData.promo_section[0].promo_text && getCreateHeidiData.promo_section[0].promo_text[0] && RichText.render(getCreateHeidiData.promo_section[0].promo_text)}
          </span>
            </div>
            }
            <div className="concept-store-container position-relative text-center pt-5">
              {getCreateHeidiData.seminars_location_title && RichText.render(getCreateHeidiData.seminars_location_title)}
              <div className="concept-store-images-container">
                {getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_image_with_map && getCreateHeidiData.concept_store.store_image_with_map.url &&
                <img className="img-fluid" src={getCreateHeidiData.concept_store.store_image_with_map.url}/>
                }
                {getCreateHeidiData.concept_store && !getCreateHeidiData.concept_store.store_image_with_map &&
                <div>
                  <img src={getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_image && getCreateHeidiData.concept_store.store_image.url}
                       className="img-fluid mt-3 mt-sm-4 main-store-img" alt=""/>
                  <img src={getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_map_image && getCreateHeidiData.concept_store.store_map_image.url}
                       className="img-fluid store-map-img" alt=""/>
                </div>
                }
              </div>
              {getCreateHeidiData.concept_store && <AppButton
                href={getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_button_link && getCreateHeidiData.concept_store.store_button_link?.url}
                target={getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_button_link?._linkType}
                className="concept-store-directions large-button"
                style={{ position: "absolute", bottom: "-15px", left: "50%", transform: "translateX(-50%)" }}>
                {getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_button_text}
              </AppButton>}
            </div>
            <div className="mt-5 text-center store-phone-numbers">
              {getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_contact_details && RichText.render(getCreateHeidiData.concept_store.store_contact_details)}
              <div className="text-center">
                <span className="store-schedule">PROGRAM: {getStoreTimeIntervals()}</span>
                <div className={isStoreOpen() ? "open mt-3" : "closed mt-3"}>
                  {isStoreOpen() ? getCreateHeidiData.concept_store?.open_now_text && getCreateHeidiData.concept_store?.open_now_text[0] && RichText.render(getCreateHeidiData.concept_store?.open_now_text) : getCreateHeidiData.concept_store?.closed_text && getCreateHeidiData.concept_store?.closed_text[0] && RichText.render(getCreateHeidiData.concept_store.closed_text)
                  }
                </div>
              </div>
              {getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_phone_numbers && getCreateHeidiData.concept_store.store_phone_numbers.map((tel, index) =>
                <div key={index.toString()}><a
                  href={`tel:${tel.store_phone_number.split(" ").join("").split("(").join("").split(")").join("").split("/").join("")}`}>{tel.store_phone_number}</a>
                </div>
              )}
              {getCreateHeidiData.concept_store && getCreateHeidiData.concept_store.store_email &&
              <div>
                <a href={`mailto:${getCreateHeidiData.concept_store.store_email}`}>{getCreateHeidiData.concept_store.store_email}</a>
              </div>
              }
            </div>
            {getCreateHeidiData.instagram_section[0] && !getCreateHeidiData.instagram_section[0].disabled &&
            <div>
              <div
                className="text-center mt-5">{getCreateHeidiData.instagram_section[0].title && getCreateHeidiData.instagram_section[0].title[0] && RichText.render(getCreateHeidiData.instagram_section[0].title)}
              </div>
              {getCreateHeidiData.instagram_section[0].instagram_feed_image && getCreateHeidiData.instagram_section[0].instagram_feed_link && getCreateHeidiData.instagram_section[0].instagram_feed_link.url &&
              <div className="mt-4 mt-sm-5 text-center">
                <a href={getCreateHeidiData.instagram_section[0].instagram_feed_link.url} target="_blank">
                  <img src={getCreateHeidiData.instagram_section[0].instagram_feed_image.url} className="img-fluid" alt=""/>
                </a>
              </div>
              }
            </div>
            }
          </div>
          <Footer data={getFooterConfigObject(data)}/>
          <BookSeminarModal {...props} data={data} selectedDuration={selectedDuration} open={open} onClose={() => setOpen(false)}/>
        </div>
        }
      </div>
    </TemplateWrapper>)
}

export default CreateYourOwnHeidi

export const pageQuery = graphql`
    query CreateYourOwnHeidiPageQuery($lang: String) {
        prismic {
            allCreate_your_own_heidi_pages(lang: $lang) {
                edges {
                    node {
                        header_image
                        header_video {
                            ... on PRISMIC__FileLink {
                                url
                            }
                        }
                        instagram_section {
                            disabled
                            title
                            instagram_feed_image
                            instagram_feed_link {
                                ... on PRISMIC__ExternalLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                        mountains_decorator
                        page_description
                        page_title
                        seminar_section_video {
                            ... on PRISMIC__FileLink {
                                url
                            }
                        }
                        seminar {
                            disabled
                            seminar_disabled_button_text
                            button_text
                            see_more_details_text
                            seminar_cost_details
                            seminar_extended_description
                            seminar_short_description
                            seminar_title
                        }
                        promo_section {
                            disabled
                            promo_button_icon
                            promo_link {
                                ... on PRISMIC__ExternalLink {
                                    _linkType
                                    url
                                }
                            }
                            promo_text
                        }
                        seminar_images_slider {
                            seminar_slide_image
                        }
                        book_seminar_form_title
                        book_seminar_form_description
                        name_input_label
                        phone_number_input_label
                        email_input_label
                        date_and_time_title
                        date_and_time_selector_placeholder
                        seminar_duration_title
                        hours_input_label
                        number_of_attendees_title
                        adults_input_label
                        children_input_label
                        minimum_age_text
                        message_input_label
                        seminars_location_title
                        seminar_section_description
                        seminar_section_image
                        seminar_section_title
                        top_button_text
                        concept_store {
                            ... on PRISMIC_Concept_store {
                                store_name
                                store_image
                                store_email
                                schedule {
                                    starting_day
                                    ending_day
                                    start_hour
                                    end_hour
                                }
                                closed_text
                                open_now_text
                                store_button_link {
                                    ... on PRISMIC__ExternalLink {
                                        url
                                    }
                                }
                                store_button_text
                                store_contact_details
                                store_map_image
                                store_image_with_map
                                store_phone_numbers {
                                    store_phone_number
                                }
                            }
                        }
                    }
                }
            },
            allMenus(lang: $lang) {
                edges {
                    node {
                        what_makes_heidi_unique_label
                        what_makes_heidi_unique_disabled
                        promo_campaign_label
                        promo_campaign_disabled
                        products_label
                        products_disabled
                        online_shop_label
                        online_shop_disabled
                        contact_disabled
                        chocolate_lover_disabled
                        contact_label
                        chocolate_lover_label
                        chocolate_label
                        chocolate_disabled
                        careers_label
                        careers_disabled
                        shops_page_label
                        shops_page_disabled
                    }
                }
            }
            allFooter_privacy_policy_linkss(lang: $lang) {
                edges {
                    node {
                        footer_privacy_policy_links {
                            link_title
                            link_resource {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                    }
                }
            }
            allCookie_consents(lang: $lang) {
                edges {
                    node {
                        cookie_consent_text
                        cookie_consent_link {
                            ... on PRISMIC__ExternalLink {
                                url
                            }
                        }
                        cookie_consent_link_text
                        cookie_consent_button_text
                    }
                }
            }
        }
    }
`
